import 'react-app-polyfill/ie11';
import 'url-search-params-polyfill';
import 'url-polyfill';
import 'whatwg-fetch';

import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';

// SheerID stuff
import { setOptions, overrideComponent } from '@sheerid/jslib';
import { defaultOptions } from './programOptions';
import { RequestOrganizationSuccessComponent } from './components/RequestOrganizationSuccessComponent';
import { RequestOrganizationSearchComponent } from './components/RequestOrganizationSearchComponent';

setOptions(defaultOptions);

// @ts-ignore
overrideComponent('RequestOrganizationSearchComponent', RequestOrganizationSearchComponent);
// @ts-ignore
overrideComponent('RequestOrganizationSuccessComponent', RequestOrganizationSuccessComponent);

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('sid-add-school-root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
